export const button = {
  root: {
    borderRadius: '2px',
    border: '0 none',
    paddingX: '0.25rem',
    paddingY: '0.3rem',
    gap: '0',
    label: {
      fontWeight: 'normal',
    },
  },
  colorScheme: {
    light: {
      root: {
        primary: {
          hoverBackground: '{colors.hover}',
          activeBackground: '{colors.main}',
          hoverBorderColor: '{colors.main}',
          activeBorderColor: '{colors.main}',
        },
      },
    },
  },
};
